export const ENDPOINTS = {
  meetings: "v2/e_meeting",
  meeting: "v2/e_meeting/:id",
  statistics: "v2/e_meeting/:id/statistics",
  vote: "v2/e_meeting/:id/vote",
  saveMandateFilesByManager:
    "v2/e_meeting/:id/participation/:participation_id/mandates",
  invalid_vote: "v2/e_meeting/:meetingId/vote/:voteId",
  paper_vote: "v2/e_meeting/:meetingId/paper_vote",
  sign: "v2/e_meeting/:id/sign",
  sign_partisipation:
    "v2/e_meeting/:meetingId/participation/:participationId/sign",
  signedProtocol: "v2/e_meeting/:meetingId/sign/download",
  resend_meeting: "v2/e_meeting/:meetingId/send_reminder",
  user: "v3/user",
  onBoarding: "v3/terms",
  profile: "v3/user/profile",
  profilePassword: "v3/user/password",
  profileApartments: "v3/user/apartments",
  language: "v2/user/language",
  // recover_password: "user/recover_password",
  // rewrite_password: "user/rewrite_password",
  change_role: "v2/user/role/change",
  change_representation: "v4/session/representation",
  login_smartid: "login/smartid/signin",
  login_mobileid: "/login/mobileid",
  validate_smartid: "/login/smartid/validate",
  confirm: "v2/e_meeting/:meetingId/confirm",
  buildings: "v2/e_meeting/:meetingId/buildings",
  participation: "v2/e_meeting/:meetingId/report/apartment_participations",
  votingSheet: "v2/e_meeting/:meetingId/voting_sheet/download",
  protoclol: "v2/e_meeting/:meetingId/protocol/download",
  votedParticipationPdf:
    "v2/e_meeting/:meetingId/participation/:participationId/pdf",
  auth_session: "v3/auth/session",
  userCooperatives: "/v3/users/cooperatives/:roleId",

  // Login
  recoverPassword: "/v3/user/recover-password",
  resetPassword: "/v3/user/reset-password",
  apiv4UserBySession: "/v4/session/user",
  apiv4Session: "/v4/session/get",
  apiv4UserRepresentation: "/v4/user/representation/:userId",
  apiv4UserRepresentationInverse: "/v4/user/representation/inverse/:userId",
  apiv4Representation: "/v4/representation",
  apiv4RepresentationDelete: "/v4/representation/:id",
  apiv4user: "/v4/user/:id",
  apiv4users: "/v4/users",

  // Haldustnet General
  advertisements: "ad?positsion=left",
  label: "v4/labels",
  periods: "v4/cooperative/:coopId/periods",
  newPeriodList: "v3/cooperative/:coopId/billing_period/list",
  newPeriod: "v3/cooperative/:coopId/billing_period/:periodId",
  postPeriod: "v3/cooperative/:coopId/billing_period",
  closePeriod: "v3/cooperative/:coopId/billing_period/:period/close",
  invoices: "v3/cooperative/:coopId/invoices",
  apartmentInvoices: "v3/cooperative/:coopId/apartment/:apartId/invoices",
  boardInvoice: "cooperative/:coopId/invoices",
  openInvoice: "downloader/invoice",
  notification: "cooperative/:id/notification",
  deleteNotification: "v3/cooperative/:id/notifications/:notificationId",
  cooperativeNotifications: "/v3/cooperative/:id/notifications",
  postCooperativeNotifications: "/v3/cooperative/:id/notification",
  singleNotification: "v3/cooperative/:id/notification/:nId",
  measurerEntries: "v3/cooperative/:coopId/readings/apartment/:apartId/:period",
  measurerImport: "v3/cooperative/:cooperativeId/readings/import",
  dashboardEntries:
    "v3/cooperative/:coopId/readings/apartment/:apartId/:period/dashboard",
  boardMemberDashboard: "v3/cooperative/:coopId/readings/:period/dashboard",
  boardMemberReadings: "v3/cooperative/:coopId/readings/:period",
  boardMemberReadingsExport: "v3/cooperative/:coopId/readings/:period/export",
  postEntries: "v3/measurer_entry/period/:period",
  patchEntries: "v3/measurer_entry/:cooperativeId/entry/:entryId",
  generateEntries: "v3/measurer_entry/:cooperativeId/period/:period/generate",
  postCooperativeEntries:
    "v3/measurer_entry/:cooperativeId/period/:period/measurer/:measurer",
  //forum
  forumList: "v3/cooperative/:coopId/forum-topic",
  postForumTopic: "v3/cooperative/:cId/forum-topic",
  forumTopic: "v3/cooperative/:cId/forum-topic/:id",
  forumReadStatus: "v3/cooperative/:coopId/mark-read",
  forumDashboardReadStatus: "v3/cooperative/:cooperativeId/read-status",
  //tasks
  tasks: "cooperative/:coopId/task/page/:page",
  taskDetail: "cooperative/:coopId/task/:id",
  maintenance: "cooperative/:coopId/maintenance",
  maintenanceTask: "cooperative/:coopId/maintenance/:id",
  maintenanceEntries: "cooperative/:coopId/maintenance/entry/page/:page",
  taskType: "cooperative/:coopId/task/types",
  task: "task/page/1",
  taskParent: "cooperative/:coopId/task",

  forumPost: "cooperative/:coopId/forum/topic/:id",
  notes: "v3/cooperative/:coopId/note",
  //contacts
  contacts: "v3/cooperative/:coopId/contacts",
  service: "v3/cooperative/:coopId/service",
  deleteService: "v3/cooperative/:coopId/service/:contactId",
  county: "v3/counties",
  countyContacts: "v3/county/contacts",
  deleteCountyContacts: "v3/county/contacts/:id",
  // gauge
  gaugeList: "v3/cooperative/:coopId/measurers",
  measurerById: "v3/cooperative/:coopId/measurers/:measurerId",
  apartment: "v3/cooperative/:coopId/apartment/:id",
  residents: "v3/cooperative/:coopId/apartment/:id/owners-and-residents",
  changeResidents:
    "v3/cooperative/:coopId/apartment/:aId/owners-and-residents/:id",
  cars: "v3/cooperative/:cId/apartment/:id/apartment-cars",
  deleteCar:
    "v3/cooperative/:cooperativeId/apartment/:id/apartment-cars/:carId",
  notifications: "v3/apartment/:aId/notifications",
  invoicing: "v3/apartment/:aId/invoicing",
  activate: "v3/activate",
  //statistics
  apartStatistics: "v3/cooperative/:coopId/apartment/:apartId/statistics",
  apartStatisticsExport:
    "v3/cooperative/:coopId/apartment/:apartId/statistics/export",
  groupStatistics: "v3/cooperative/:coopId/group/:groupId/statistics",
  groupStatisticsExport:
    "v3/cooperative/:coopId/group/:groupId/statistics/export",
  cooperativeStatistics: "v3/cooperative/:coopId/statistics",
  cooperativeStatisticsExport: "v3/cooperative/:coopId/statistics/export",
  cooperatives: "v3/cooperative/:coopId/details",
  //documents
  postDocument: "v3/documents/:cId",
  documents: "v3/documents/cooperative/:coopId",
  document: "v3/documents/:cId/:id",
  documentZip: "v3/documents/:cId/zip/:id",
  documentMultipleZip: "v3/documents/:cId/multiple/zip",
  // files
  //v2
  file: "v2/file",
  deleteFile: "v2/file/:id",
  agendaItem: "v2/e_meeting/:meetingId/item/:itemId",
  agendaItemFile: "v2/e_meeting/:meetingId/item/:itemId/file/:fileId",
  //v3
  fileUploadWithType: "v3/files",
  files: "v3/files/:cooperativeId",
  actionFiles: "v3/files/:cId/:id",
  deleteFiles: "v3/files/:id",
  cloneFiles: "v3/files/clone",

  meetingFile: "v2/e_meeting/:meetingId/file/:fileId",
  voteFile: "v2/e_meeting/:meetingId/vote/:voteId/file/:fileId",
  boardMembers: "v2/e_meeting/:meetingId/board_members",

  // Admin modules
  documentCatalogues: "/v3/document_type",
  documentCatalogue: "/v3/document_type/:id",
  documentCatalogueRelations: "/v3/document_type/:id/has_relations",
  roles: "/v3/roles",
  updateRoles: "/v3/roles/:id",
  updateUserRole: "/v3/users/role/:id",
  userRole: "/v3/users/role/:id",
  rolesWithPrivileges: "/v3/roles/privileges",
  rolesPrivileges: "/v3/roles/privileges",
  privilege: "/privilege",
  newPrivileges: "/v3/privileges",
  updatePrivileges: "/v3/privileges/:id",
  //Cooperative
  cooperativeAdd: "/v3/cooperative/add",
  cooperativeAll: "/v3/cooperative/all",
  cooperativeSingle: "/v3/cooperative/:id/without_groups",
  cooperativePatch: "/v3/cooperative/:id",
  cooperativeDetail: "/v3/cooperative/:id/details",
  cooperativeBuilding: "/v3/cooperative/:id/building",
  cooperativeBuildings: "/v3/cooperative/:id/buildings",
  cooperativeApartment: "/v3/cooperative/:cooperativeId/apartment/:apartmentId",
  cooperativeApartmentDeletable:
    "/v3/cooperative/:cooperativeId/apartment/:apartmentId/deletable",
  cooperativeApartments: "/v3/cooperative/:cooperativeId/apartments",
  cooperativeResidentExport: "/v3/cooperative/:coopId/residents/export",
  cooperativeExistingModules: "/v3/cooperative/:id/existing_modules",
  cooperativeDeleteModule: "/v3/cooperative/:id/module/:module",
  //Apartment
  apartmentDetail: "/v3/cooperative/:cId/apartment/:aId/details",
  //Notifications
  adminNotifications: "/v3/notifications",
  newAdminNotifications: "/v3/notification/send",
  adminActionNotifications: "/v3/notifications/:notificationId",
  //Users
  adminUsers: "/v3/users",
  adminUsersDetail: "/v3/user/:id",
  adminResetPassword: "/v3/user/:id/password",
  adminAddRole: "/v3/users/:id/role",
  adminUpdateRole: "/v3/users/role/:roleId",
  adminRemoveRole: "/v3/users/role/:id",
  adminUpdateUser: "/v3/users/:id",
  adminAddMultipleUsers: "/v3/users/:id",
  adminDeleteUser: "/v3/users/:id",
  adminArchiveUser: "/v3/users/:id/archive",
  adminActivateUser: "/v3/users/:id/activate",
  adminTask: "task/accepting",
  adminTaskAcceptance: "task/accepting/:id",
  adminTaskCount: "task/waiting_count",
  adminTaskDetail: "task/:id",
  // Search
  search: "/v3/search",
};
